import { render, staticRenderFns } from "./TableCardR.vue?vue&type=template&id=ac9ae18c&scoped=true&"
import script from "./TableCardR.vue?vue&type=script&lang=js&"
export * from "./TableCardR.vue?vue&type=script&lang=js&"
import style0 from "./TableCardR.vue?vue&type=style&index=0&id=ac9ae18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9ae18c",
  null
  
)

export default component.exports